import React from 'react';
import PropTypes from 'prop-types';
import MathquillUIElement from 'mathquill-ui';
import qtiConstants from '../../../../qti/Constants';
import interactionParserUtils from '../../../../qti/parser/question/interactions/InteractionParserUtils';

class TextEntryCorrectResponsesInfo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.getMathCorrectResponsesOutput.bind(this);
        this.getNumericCorrectResponsesOutput.bind(this);
        this.getCorrectResponsesOutput.bind(this);
    }

    getMathCorrectResponsesOutput(correctResponses) {
        return correctResponses.map((correctResponse, index) => {
            const showSeparator = (correctResponses.length - 1) > index;
            return (
                <span key={correctResponse}>
                    <MathquillUIElement
                        triggerOnClick={false}
                        isStaticMathElement
                        mathquillText={correctResponse}
                    />
                    {
                        showSeparator ?
                            ',  ' : null
                    }
                </span>
            );
        });
    }

    getNumericCorrectResponsesOutput(correctResponses) {
        // numeric is always provided as two numbers
        const [first, last] = correctResponses;
        if (first !== last && last !== undefined) {
            return `${first} - ${last}`;
        }
        return first;
    }

    getNumericSimulationsCorrectResponsesOutput(correctResponses) {
        return correctResponses.join(', ');
    }

    getCorrectResponsesOutput() {
        const { correctResponses, model } = this.props;
        const { baseTypes, interactionType } = qtiConstants;

        if ([interactionType.NUMERIC_SIMULATIONS, interactionType.SYMBOLIC_MATH].includes(model.interactionType)) {
            return interactionParserUtils.prepareDynamicMathResponse(correctResponses[0]);
        }
        if (model.baseType === baseTypes.FLOAT) {
            return this.getNumericCorrectResponsesOutput(correctResponses);
        }
        if (model.interactionType === interactionType.MATH) {
            return this.getMathCorrectResponsesOutput(correctResponses);
        }

        return correctResponses.join(', ');
    }

    render() {
        const { outcomeIsCorrect, correctResponses } = this.props;

        if (!correctResponses || outcomeIsCorrect === 'true') {
            return null;
        }

        return (
            <span className="inline-correct-text">
                ({this.getCorrectResponsesOutput()})
            </span>
        );
    }
}

TextEntryCorrectResponsesInfo.propTypes = {
    model: PropTypes.object.isRequired, // model taken from responseModels related to this interaction
    outcomeIsCorrect: PropTypes.string,
    correctResponses: PropTypes.array,
};

export default TextEntryCorrectResponsesInfo;
